import posthog from 'posthog-js'

if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_TOKEN!, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    autocapture: false,
    debug: false,
    defaults: '2026-01-30',
    opt_out_capturing_by_default: true,
    disable_surveys: true,
  })
}
